export type SymbiosisStuckedResponse = {
    hash: string;
    chainId: number;
};
